export default "__VITE_ASSET__Cvaek1uP__"